const classNames = (...styles) => styles.filter(s => !!s).join(' ');

export { classNames };
